export * from './auth.guard';


// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/guards/index.ts